import Settings from '../olr-common/Settings';

export default function StudentService($http) {

  this.getAllStudents = function(){
  	let url = Settings.backendEnv + "/api/v1/students";
    return $http({method: 'GET',url: url});
  };

  this.getStudentsByChar = function(character){
  	let url = Settings.backendEnv + "/api/v1/students/" + character;
  	var req = {
      method:  "GET",
      url:    url
    };
    return $http(req); 
  };
}



/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-api/StudentService.js
 **/